import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext.jsx';
import { createIssue, issuePath } from '../lib/newsletter.js';
import NewsletterForm from '../components/newsletter/NewsletterForm.jsx';

export default function NewsletterNew() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user, isAdmin } = useAuth();
  const [busy, setBusy] = useState(false);

  if (!isAdmin) {
    return (
      <div className="mx-auto max-w-2xl px-8 pb-20 pt-32 text-center">
        <h1 className="font-serif text-3xl text-gold-light">{t('common.error')}</h1>
        <p className="mt-3 text-ink-secondary">{t('newsletter.form.adminOnly')}</p>
      </div>
    );
  }

  async function handleSubmit(form) {
    setBusy(true);
    try {
      const created = await createIssue(form, { authorId: user.id });
      navigate(issuePath(created));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="mx-auto max-w-4xl px-6 pb-20 pt-28">
      <header className="mb-8">
        <div className="section-label">{t('newsletter.form.newLabel')}</div>
        <h1 className="font-serif text-3xl font-semibold text-cream">{t('newsletter.form.newHeading')}</h1>
        <p className="mt-2 text-sm text-ink-secondary">{t('newsletter.form.newSubheading')}</p>
      </header>

      <NewsletterForm
        submitLabel={t('newsletter.form.save')}
        onSubmit={handleSubmit}
        onCancel={() => navigate('/newsletter')}
        busy={busy}
      />
    </div>
  );
}
